export default "<app-question [dataPath] = \"'151f7301-1eb7-4170-ba20-6fc9418ff5c4'\"></app-question>"